import dynamic from "next/dynamic";
import React, { Suspense, useState } from "react";

const TabItem = dynamic(() => import("./TabItem"), {
  suspense: true,
});

export interface Tab {
  icons?: React.ReactNode;
  title: string;
  key: string;
  panel: React.ReactNode;
}

interface TabProps {
  tabs: Tab[];
  defaultKey: string;
}

const Tab: React.FC<TabProps> = ({ tabs, defaultKey }) => {
  const [active, setActive] = useState<string>(defaultKey);

  return (
    <div className="w-full">
      <div className="w-full flex text-lg font-normal bg-gray-200">
        <Suspense fallback={<></>}>
          {tabs.map((tab, index) => (
            <TabItem
              onClick={() => setActive(tab.key)}
              key={index}
              active={active === tab.key}
              title={tab.title}
              icon={tab.icons}
            />
          ))}
        </Suspense>
      </div>
      <div className="bg-white border border-gray-300 w-full">
        <div className="px-3 py-2 w-full">
          <Suspense fallback={<></>}>
            {tabs.filter((tab) => tab.key === active)[0].panel}
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default Tab;
